export default __webpack_public_path__ + "static/media/limit_85.07be95ec.svg";